import axios from 'axios'
import URL from '../../../utils/urls'
import { CodatCompany, CodatDataConnection } from '../adf-app-types'

export async function getCodatCompanies(): Promise<CodatCompany[]> {
    const results: any = await getCodatCompaniesRaw()

    let converted: CodatCompany[]
    try {
        converted = convertArrayToCodatCompanies(results.results)
    } catch (error) {
        console.log('Error converting Codat companies data to type. Check that the data from Codat matches the CodatCompany type: ', error)
        return [];
    }

    return converted;
}

async function getCodatCompaniesRaw() {
    let response = { data: [] }
    try {
        response = await axios.get(URL.codat.getCodatCompanies)
    } catch (error: any) {
        console.log('Error getting Codat companies from data source: ', error)
    }

    const codatCompanies = response.data
    return codatCompanies; 
}

function convertArrayToCodatCompanies(rawData: any[]): CodatCompany[] {
    if (!Array.isArray(rawData)) {
        console.warn('Raw data is not convertible to type.')
        return [];
    }
        
    return rawData.map(item => ({
        id: item?.id ?? 'None',
        dataConnections: convertArrayToCodatDataConnection(item?.dataConnections),
        name: item?.name ?? 'None',
        platform: item?.platform ?? 'None'
    }));
}

function convertArrayToCodatDataConnection(rawData: any[]): CodatDataConnection[] {
    if (!Array.isArray(rawData)) {
        console.warn('Raw data is not convertible to type.')
        return [];
    }

    return rawData.map(item => ({
        id: item.id ?? 'None',
        created: item.created ?? 'None',
        integrationId: item.integrationId ?? 'None',
        status: item.status ?? 'None',
        sourceType: item.sourceType ?? 'None'
    }))
}